export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref10757.4b03fd0d.jpg";